// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
import { Injectable } from '@angular/core';
import { DeleteTemplateRequest, DeleteTemplateResponse, ListTemplatesRequest, ListTemplatesResponse } from './objects/';
import {
  DeleteTemplateRequestInterface,
  DeleteTemplateResponseInterface,
  ListTemplatesRequestInterface,
  ListTemplatesResponseInterface,
} from './interfaces/';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HostService } from '../_generated/host.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TemplateApiService {
  constructor(private http: HttpClient, private hostService: HostService) {}

  private apiOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
  }

  listTemplates(r: ListTemplatesRequest | ListTemplatesRequestInterface): Observable<ListTemplatesResponse> {
    const request = (<ListTemplatesRequest>r).toApiJson ? <ListTemplatesRequest>r : new ListTemplatesRequest(r);
    return this.http
      .post<ListTemplatesResponseInterface>(
        this.hostService.hostWithScheme() + '/wsp_admin_center.v1.TemplateService/ListTemplates',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(map((resp) => ListTemplatesResponse.fromProto(resp)));
  }

  deleteTemplate(r: DeleteTemplateRequest | DeleteTemplateRequestInterface): Observable<DeleteTemplateResponse> {
    const request = (<DeleteTemplateRequest>r).toApiJson ? <DeleteTemplateRequest>r : new DeleteTemplateRequest(r);
    return this.http
      .post<DeleteTemplateResponseInterface>(
        this.hostService.hostWithScheme() + '/wsp_admin_center.v1.TemplateService/DeleteTemplate',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(map((resp) => DeleteTemplateResponse.fromProto(resp)));
  }
}
